import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
export var EU_COUNTRIES = new Set(["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "GB"]);
export var BREAKPOINTS; // Rescued from browser.js

(function (BREAKPOINTS) {
  BREAKPOINTS[BREAKPOINTS["ExtraExtraSmall"] = 320] = "ExtraExtraSmall";
  BREAKPOINTS[BREAKPOINTS["ExtraSmall"] = 375] = "ExtraSmall";
  BREAKPOINTS[BREAKPOINTS["Small"] = 576] = "Small";
  BREAKPOINTS[BREAKPOINTS["Medium"] = 768] = "Medium";
  BREAKPOINTS[BREAKPOINTS["Large"] = 992] = "Large";
  BREAKPOINTS[BREAKPOINTS["ExtraLarge"] = 1200] = "ExtraLarge";
})(BREAKPOINTS || (BREAKPOINTS = {}));

export var VIEWPORTS;

(function (VIEWPORTS) {
  VIEWPORTS[VIEWPORTS["Mobile"] = 1] = "Mobile";
  VIEWPORTS[VIEWPORTS["Tablet"] = 2] = "Tablet";
  VIEWPORTS[VIEWPORTS["Desktop"] = 3] = "Desktop";
})(VIEWPORTS || (VIEWPORTS = {}));